export const DEFAULT_PAGE_SIZE = 10;

export const SELECT_LOCATION_MODE = {
	enterLatitudeLongitude: "location-enter-latitude-longitude-select-on-map",
	locationAdd: "location-add",
	locationSearch: "location-search",
};

export const ACTION_SETTING = "Configuracion";
export const ACTION_FILTER = "Filtrar";
export const ACTION_IMPORTAR = "Importar";
export const ACTION_SESSION = "Sesion";
export const ACTION_CREATE_EXTRACTION = "Crear extracción";

export const APP_NAME = "Palino GIS";

export const DEBOUNCE_TIME = 500; //mili seconds

export const EXTRACTION_TYPES = ["floor", "drilling"];

export const ROLES = { admin: "admin", collaborator: "collaborator", user: "user" };
